/**
 * @file PricingNoteInput.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-11-03
 * @modified 2026-11-03
 * @description Pricing & Costing: the optional note beside a hand-typed cost
 *              or sale price (Cam, 3 Nov 2026 — "Please add the option to
 *              include a note when hand typing a cost or sale price in Pricing
 *              & Costing"). One line, at most 200 characters (utils/
 *              pricingCosting NOTE_MAX). Kept with the figure while it is set,
 *              sent with the confirm, shown on the confirmed cell and in the
 *              line's history. Greyed with the reason before
 *              migrations/pricing_line_choices.sql has run. Presentational: the
 *              caller keeps the value.
 */

import React from 'react';
import { NOTE_MAX } from '../utils/pricingCosting';

export const NOTE_NOT_READY = 'Not ready — migration pricing_line_choices.sql has not run';

function PricingNoteInput({ value = '', onChange, disabled = false, notReady = false, ariaLabel = 'Note for this figure' }) {
  const text = String(value || '');
  const off = disabled || !!notReady;
  return (
    <span className={`pc-note-input${off ? ' off' : ''}`} title={notReady ? NOTE_NOT_READY : 'Kept with the figure when it is confirmed — shown on the line and in its history'}>
      <span className="material-symbols-rounded" aria-hidden="true">sticky_note_2</span>
      <input type="text" value={notReady ? '' : text} maxLength={NOTE_MAX} disabled={off}
        placeholder={notReady ? 'Note — not ready yet' : 'Note (optional)'} aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.value.replace(/[\r\n]+/g, ' '), e.target)} />
      {!notReady && text.length > NOTE_MAX - 40 && <span className="pc-note-count">{text.length}/{NOTE_MAX}</span>}
    </span>
  );
}

export default PricingNoteInput;
